export const elementdata = [
    {
        "id": 1,
        "brand": "QRUIL",
        "branddesc": "One of the greatest project i have ever done with USA client on fiverr.",
        "brandused": "HTML, CSS, Tailwind CSS Javascript, React js and (some other libraries)",
        "hoverimg": "/qruillogo.svg",
        "websitelink": "https://qruil.com/landing",
    },
    {
        "id": 2,
        "brand": "FUT NEXT",
        "branddesc": "Developed a clean and responsive UI for FUT NEXT, enhancing user interaction and overall experience.",
        "brandused": "HTML, CSS, Tailwind CSS Javascript, Next js and (some other libraries)",
         "hoverimg": "/futtnextlogo.svg",
         "websitelink": "https://www.futnext.com/",
    },
    {
        "id": 3,
        "brand": "Dropleather",
        "branddesc": "I have good experience working with Dropleather, a premium leather brand.",
        "brandused": "HTML, CSS, Tailwind CSS Javascript, Next js, Scroll-base animation and Smooth scroll",
        "hoverimg": "/dropleather.png",
        "websitelink": "https://dropleather.com/",
    },
    {
        "id": 4,
        "brand": "SUNDOWN",
        "branddesc": "Greate animated project. Through this project, I've honed my skills in coding, design, and creating engaging user experences.",
        "brandused": "HTML, CSS, Tailwind CSS Javascript, React js, Smooth scroll and animated libraries",
        "hoverimg": "/sundownlogo.svg",
        "websitelink": "https://sundown-wine.vercel.app/",
    },
    {
        "id": 5,
        "brand": "CONTINUNM",
        "branddesc": "Greate project, greate expericence.",
        "brandused": "HTML, CSS, Tailwind CSS Javascript, Next js, animated libraries",
        "hoverimg": "/continuum.svg",
        "websitelink": "https://continuumtest.vercel.app/",
    },
    {
        "id": 6,
        "brand": "SIGNIFICO",
        "branddesc": "Developed a dynamic, scroll-animated project Significo, showcasing innovative UI elements and seamless user interaction.",
        "brandused": "HTML, CSS, Tailwind CSS Javascript, React js, Scroll-base animation and Smooth scroll",
        "hoverimg": "/significo.svg",
        "websitelink": "https://significo-five.vercel.app/",
    },
    
    
    
]